import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import message from './modules/message'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    message
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js